import { Pipe, PipeTransform } from '@angular/core';
import { keys } from 'lodash';

@Pipe({
  name: 'keys',
  standalone: true,
})
export class KeysPipe implements PipeTransform {
  public transform(value: unknown): string[] {
    return keys(value);
  }
}
